<template>
<div class="tab-pane fade" id="CurrentExchangeRate" role="tabpanel"  aria-labelledby="home-tab">


  <div class="row" style="overflow-x: auto; white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInputexchange"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filterexchange"
              type="search"
              id="filterInputexchange"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="getAllExchangeReports"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filterexchange"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                 

                      <template v-slot:cell(image)="data" align="center">
                        <img v-if="data.value != '' " :src="data.value" alt="Smiley face">
                        
                      </template>


                    
                    </b-table>


                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="getTotalRows"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

             
                </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { mapGetters } from "vuex";
    import * as TYPES from "@/store/mutation-types";
    import api from '@/api'


export default {
  name: "clientprofitlossreport",
  props: {
    usid:String,
    showname : String
  },
  data: function() {
    return {
        mydatas : [],
        dataTable:null,
        dataTableAnak:null,
        indukdatas : [],
        activeuser : "",
        activetype : "",
        activeket : "Agent",
         selected: [], 
      selectrows : [],
      rowdeposit : [],
      rowwithdraw : [],
      dataTableList:null,
      boxOne: '',
      fields: [
          { key: 'id', label: '', sortable: true,  },
          { key: 'name', label: '',sortable: true,},
          { key: 'image', label: ''},
          { key: 'value', label: '',sortable: true,}      
        ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filterexchange: null,
      filterOn: [],
    }
  },
  components: {
    Datepicker
  },
  computed: {
   ...mapGetters(["allExchangeReport","singleUser"]),
   getAllExchangeReports(){
      return this.allExchangeReport
   },
    getUser(){
      return this.singleUser
   },
   getTotalRows(){
     return this.allExchangeReport.length    
   }
  },
  methods : {
    getreport(){
        this.$store.dispatch(TYPES.FETCH_CUREXCHANGE)
       // debugger;
       // this.mydatas = this.getAllExchangeReports;   
        //debugger;  
    },

  },
  mounted(){
    this.getreport();
    this.dataTableAnak = $(this.$refs.tabexchange).DataTable({});
    setTimeout(() => this.mydatas = fakeData(50), 1000);
  },
  watch: {
  getAllExchangeReports(val) {
    this.dataTableAnak.destroy();
    this.$nextTick(() => {
      this.dataTableAnak = $(this.$refs.tabexchange).DataTable()
    });
  }
},
}
</script>